// Updated: 02-04-2026
// Changes:
// - Search input for property name / location
// - A–Z / Z–A / Newest / Oldest sort options
// - Commercial / Residential category filter
// - Status filter kept from original

import React from "react";
import { Search } from "lucide-react";

export default function PropertyFilters({ filters, setFilters, inline = false }) {
  const content = (
    <>
      {/* Search */}
      <div className="filter-search-wrapper">
        <Search size={15} className="filter-search-icon" />
        <input
          className="filter-search"
          type="text"
          placeholder="Search by name or location..."
          value={filters.search || ""}
          onChange={(e) => setFilters({ ...filters, search: e.target.value })}
        />
      </div>

      {/* Sort */}
      <select
        className="filter-select"
        value={filters.sort || "newest"}
        onChange={(e) => setFilters({ ...filters, sort: e.target.value })}
      >
        <option value="newest">Newest First</option>
        <option value="oldest">Oldest First</option>
        <option value="az">Name: A → Z</option>
        <option value="za">Name: Z → A</option>
        <option value="price_asc">Price: Low → High</option>
        <option value="price_desc">Price: High → Low</option>
      </select>

      {/* Category Filter */}
      <select
        className="filter-select"
        value={filters.category || "all"}
        onChange={(e) => setFilters({ ...filters, category: e.target.value })}
      >
        <option value="all">All Categories</option>
        <option value="residential">Residential</option>
        <option value="commercial">Commercial</option>
      </select>

      {/* Listing Type Filter */}
      <select
        className="filter-select"
        value={filters.listingType || "all"}
        onChange={(e) => setFilters({ ...filters, listingType: e.target.value })}
      >
        <option value="all">Sale &amp; Rent</option>
        <option value="sale">For Sale</option>
        <option value="rent">For Rent</option>
      </select>

      {/* Status Filter */}
      <select
        className="filter-select"
        value={filters.status || "all"}
        onChange={(e) => setFilters({ ...filters, status: e.target.value })}
      >
        <option value="all">All Status</option>
        <option value="available">Available</option>
        <option value="under_offer">Under Offer</option>
        <option value="sold">Sold</option>
        <option value="rented">Rented</option>
        <option value="unavailable">Unavailable</option>
        <option value="under_construction">Under Construction</option>
        <option value="other">Other</option>
      </select>
    </>
  );

  // When `inline` is true, return raw children so caller can wrap them
  // alongside other sibling filter selects in a single flex container.
  if (inline) return content;

  // Default: render with own wrapper (backward-compatible)
  return <div className="filters-container">{content}</div>;
}